import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import 'react-tooltip/dist/react-tooltip.css'

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  //   <App />
  // </StrictMode>,
    <App />
)
